import * as yup from 'yup';

export const stockAdjustmentSchema = (messages: any) =>
  yup.object().shape({
    name: yup
      .string()
      .trim()
      .typeError(
        messages[
          'productAttributes.productAttributesInfo.edit.nameRequired'
        ].toString(),
      )
      .required(
        messages[
          'productAttributes.productAttributesInfo.edit.nameRequired'
        ].toString(),
      ),
  });
